import { Reveal, SectionTag, CrossDoodle, Polaroid, Tape } from "@/components/doodles";

const VERSES = [
  { text: "I can do all things through Christ who strengthens me.", ref: "PHILIPPIANS 4:13" },
  { text: "Do you not know that your bodies are temples of the Holy Spirit?", ref: "1 CORINTHIANS 6:19-20" },
  { text: "But those who hope in the LORD will renew their strength. They will soar on wings like eagles.", ref: "ISAIAH 40:31" },
  { text: "Let us not become weary in doing good, for at the proper time we will reap a harvest.", ref: "GALATIANS 6:9" },
  { text: "She is clothed with strength and dignity, and she laughs without fear of the future.", ref: "PROVERBS 31:25" },
  { text: "I have fought the good fight, I have finished the race, I have kept the faith.", ref: "2 TIMOTHY 4:7" },
  { text: "Commit to the LORD whatever you do, and he will establish your plans.", ref: "PROVERBS 16:3" },
  { text: "Be strong and courageous. Do not be afraid; the LORD your God goes with you.", ref: "JOSHUA 1:9" },
  { text: "Whatever you do, work at it with all your heart, as working for the Lord.", ref: "COLOSSIANS 3:23" },
  { text: "For physical training is of some value, but godliness has value for all things.", ref: "1 TIMOTHY 4:8" },
  { text: "The LORD is my strength and my shield; my heart trusts in him.", ref: "PSALM 28:7" },
  { text: "And let us run with perseverance the race marked out for us.", ref: "HEBREWS 12:1" },
];

const VALUES = ["encouragement", "discipline", "grace", "growth"];
const VALUE_STYLES = ["bg-gold text-ink", "bg-pink text-cream", "bg-electric text-ink", "bg-lime text-ink"];

export const Faith = () => {
  const verse = VERSES[new Date().getMonth() % VERSES.length];

  return (
    <section id="faith" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <div className="card-pop bg-ink text-cream overflow-hidden" data-testid="faith-panel">
          <div className="grid lg:grid-cols-2">
            <div className="p-8 sm:p-12 lg:p-16">
              <SectionTag className="text-gold">FAITH • FITNESS • PURPOSE</SectionTag>
              <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-4 leading-[0.95]">
                TRAIN LIKE IT <span className="hl-pink">MATTERS</span>.
                <br />
                BECAUSE IT DOES.
              </h2>
              <span className="font-bebas tracking-[0.25em] text-xs text-cream/50 block mt-8" data-testid="verse-of-month-label">
                ★ VERSE OF THE MONTH ★
              </span>
              <blockquote className="mt-3 border-l-4 border-gold pl-5" data-testid="faith-verse">
                <p className="font-hand text-2xl sm:text-3xl leading-snug">
                  "{verse.text}"
                </p>
                <cite className="font-bebas tracking-[0.25em] text-sm text-cream/60 not-italic block mt-3">
                  — {verse.ref}
                </cite>
              </blockquote>
              <p className="mt-6 text-base sm:text-lg font-semibold text-cream/75 max-w-lg leading-relaxed">
                My coaching is Christ-centered: encouragement over ego, purpose over pressure. Whether you share my faith
                or not, you get the same thing every session — honesty, hope, and a coach who believes in you on the days
                you don't.
              </p>
              <div className="mt-8 flex flex-wrap gap-3" data-testid="faith-values">
                {VALUES.map((v, i) => (
                  <span key={v} className={`font-hand text-xl sm:text-2xl px-3 py-1 border-[2.5px] border-cream/90 shadow-[3px_3px_0_rgba(249,248,246,0.6)] ${VALUE_STYLES[i]} ${i % 2 ? "rotate-1" : "-rotate-1"}`}>
                    {v}
                  </span>
                ))}
              </div>
            </div>
            <div className="relative p-8 sm:p-10 lg:p-14 flex items-center justify-center min-h-[440px]" data-testid="faith-photos">
              <div className="relative w-full max-w-sm py-10">
                <div className="relative w-full max-w-[300px] mx-auto">
                  <Polaroid
                    src="/img/faith1.jpeg"
                    alt="Baptism Sunday at Rosa's church"
                    caption="my foundation"
                    rotate="rotate-2"
                    className="w-full"
                  />
                  <Tape className="-top-3 left-1/2 -translate-x-1/2 -rotate-2" />
                </div>
                <div className="absolute bottom-24 -right-2 sm:-right-6 w-[48%]">
                  <Polaroid
                    src="/img/faith2.jpeg"
                    alt="Rosa sharing her story on stage at church"
                    caption="sharing my story"
                    rotate="rotate-6"
                    className="w-full"
                  />
                  <Tape className="-top-2 left-6 rotate-[14deg]" />
                </div>
                <CrossDoodle className="absolute top-2 left-2 w-6 text-gold" />
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
  );
}

